import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TotalShipTableComponent } from './total-ship-table.component';

const routes: Routes = [
  {
    path: '',
    component: TotalShipTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TotalShipTableRoutingModule {}
